import React from 'react';
import { SwiperSlide, Swiper } from 'swiper/react';
import {
  useGetMovieSimiliarQuery,
  useGetTvSimiliarQuery,
} from '../../services/movieApi';
import MovieCard from './MovieCard';

const MovieSimiliar = ({ movieId, tvId }) => {
  const { data: similiarMovie } = useGetMovieSimiliarQuery({
    movieId,
  });

  const { data: similiarTv } = useGetTvSimiliarQuery({
    tvId,
  });
  console.log(similiarMovie);
  return (
    <div className="flex flex-col container mx-auto px-5 pb-20 gap-2 md:px-6 md:py-6 lg:pb-10 ">
      <h1 className="text-sm md:text-xl font-bold">
        {movieId != undefined ? 'Similiar Movies' : 'Similiar Tv'}
      </h1>
      <div className="movie-list ">
        <Swiper grabCursor={true} spaceBetween={10} slidesPerView="auto">
          {movieId && (
            <>
              {similiarMovie?.results.map((item, i) => (
                <SwiperSlide key={i}>
                  <MovieCard item={item} />
                </SwiperSlide>
              ))}
            </>
          )}
          {tvId && (
            <>
              {similiarTv?.results.map((item, i) => (
                <SwiperSlide key={i}>
                  <MovieCard item={item} />
                </SwiperSlide>
              ))}
            </>
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default MovieSimiliar;
